function customInputNumber($input) {
    const id = $input.attr('id');

    $input.wrap('<div class="custom-wrapper number ' + id + '"></div>');
    const $wrapper = $input.parent('.custom-wrapper');

    $wrapper.prepend('<i class="fa-solid fa-minus minus"></i>');
    $wrapper.append('<i class="fa-solid fa-plus plus"></i>');

    $input.attr('type', 'text');

    const val = $input.val();

    $input.on('keydown', function(e) {
        if (e.keyCode != 8 && (e.keyCode < 48 || e.keyCode > 57)) {
            e.preventDefault();
            return false;
        }

        const val = parseInt($input.val() + event.key);
        const min = parseInt($input.attr('min'));
        const max = parseInt($input.attr('max'));

        if (val < min || val > max) {
            e.preventDefault();
            return false;
        }
    });

	const $plus = $wrapper.find('.plus');
	const $minus = $wrapper.find('.minus');

    if ($input.prop('readonly')) {
		$wrapper.addClass('disabled');
        $plus.prop('disabled', true);
        $minus.prop('disabled', true);
    } else {
		$plus.on('click', function(e) {
			e.preventDefault();

			const $target = $(this);

			const min = parseInt($input.attr('min'));
			const max = parseInt($input.attr('max'));

			let val = parseInt($input.val());

			if (val == max) {
				return;
			}

			val += 1;
			$input.val(val);

			if (val == max) {
				$target.prop('disabled', true);
			}

			if (val > min) {
				$minus.prop('disabled', false);
			}

			$input.change();
		});

		$minus.on('click', function(e) {
			e.preventDefault();

			const $target = $(this);
			const min = parseInt($input.attr('min'));
			const max = parseInt($input.attr('max'));

			let val = parseInt($input.val());

			if (val == min) {
				return;
			}

			val -= 1;
			$input.val(val);

			if (val == min) {
				$target.prop('disabled', true);
			}
			if (val < max) {
				 $plus.prop('disabled', false);
			}

			$input.change();
		});
	}
}

export default customInputNumber;
